










































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { dictServe, doublePrevention } from '@/api/installServer';
import publicProp from '@/views/planManagementPreplan/publicProp.vue';

@Component({
  components: { PagingUnit, CollapseTransition, publicProp },
  mixins: [TableStripe],
})
export default class PlanManagementPreplan extends Vue {
  private searchForm: any = {
    type: '', // 演练方式
    search: '', // 模糊搜索
  };
  timers: any = []; // 查询时间

  typeList: any = []; // 应急队伍级别
  private tableLoading = false; // loading...
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;

  private formShow = true; // 是否显示搜索表单内容
  isShowForm() {
    this.formShow = !this.formShow;
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          doublePrevention.deleteEmergencyPlan(data.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.publicProp as any).showDialog(passValue);
    }
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.timers = [];
    this.searchForm = {
      type: '',
      search: '',
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getEmergencyPlan({
        // ...this.queryDataForm,
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        type: this.searchForm.type ? this.searchForm.type : null, // 预案类别
        search: this.searchForm.search ? this.searchForm.search : null, // 预案名称
        reviseDateStart: this.timers && this.timers.length ? this.timers[0] : null, // 修订日期搜索开始日期
        reviseDateEnd: this.timers && this.timers.length ? this.timers[1] : null, // 修订日期搜索结束日期
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.queryDataForm.pageSize = res.data.size;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 预案类型 的下拉
  getTypeList() {
    dictServe.getDetailsMapByName('emergencyPlanType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.typeList = helpArr;
      } else {
        this.$message.warning('获取预案类型下拉数据失败！');
      }
    });
  }

  created() {
    this.getTableData();
    this.getTypeList();
  }
}
